import * as THREE from 'three';
import { RENDER, PLAYER } from '../constants';

export class Engine {
  renderer: THREE.WebGLRenderer;
  scene: THREE.Scene;
  camera: THREE.PerspectiveCamera;
  canvas: HTMLCanvasElement;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;

    const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    this.renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: !isMobile, // disable antialias on mobile
      powerPreference: 'high-performance',
    });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(isMobile ? 1 : Math.min(window.devicePixelRatio, RENDER.MAX_PIXEL_RATIO));
    this.renderer.shadowMap.enabled = !isMobile; // no shadows on mobile
    this.renderer.shadowMap.type = THREE.PCFShadowMap; // faster shadow type
    this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
    this.renderer.toneMappingExposure = 0.5;

    this.scene = new THREE.Scene();
    this.scene.fog = new THREE.FogExp2(RENDER.FOG_COLOR, RENDER.FOG_DENSITY);

    this.camera = new THREE.PerspectiveCamera(
      PLAYER.FOV_NORMAL,
      window.innerWidth / window.innerHeight,
      0.01,
      isMobile ? 60 : 100
    );
    this.camera.position.set(0, PLAYER.HEIGHT, 0);

    const ambient = new THREE.AmbientLight(RENDER.AMBIENT_COLOR, RENDER.AMBIENT_INTENSITY);
    this.scene.add(ambient);

    window.addEventListener('resize', () => this.onResize());
  }

  private onResize(): void {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  }

  render(): void {
    this.renderer.render(this.scene, this.camera);
  }

  dispose(): void {
    this.renderer.dispose();
  }
}
